import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule, MatProgressSpinnerModule, MatRadioModule } from '@angular/material';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { ArchiveLocationSectorApi } from './archive-location-sectors.api';
import { ArchiveSectorDialogComponent } from './archive-sector-dialog.component';
import { ArchiveSectorDialogService } from './archive-sector-dialog.service';

@NgModule({
  declarations: [
    ArchiveSectorDialogComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    FormsModule,
    TranslateModule,
    MatRadioModule,
    MatProgressSpinnerModule
  ],
  entryComponents: [
    ArchiveSectorDialogComponent
  ],
  providers: [
    ArchiveSectorDialogService,
    ArchiveLocationSectorApi
  ]
})
export class ArchiveSectorDialogModule {}
